import React from 'react';

import { PaymentTime } from '@/booking/interfaces/PaymentTime.interface';
import {
  useCurrencyPreview,
  usePreviewingAlternativeCurrency,
} from '@/currency-preview';
import type { IFinancialAmountInstance } from '@/finance';
import { useTranslation } from '@/i18n';
import { BodySmall } from '@/ui/typography';

export const AlternativeCurrencyConfirmationWarning = ({
  total,
  paymentTime,
}: {
  total?: IFinancialAmountInstance;
  paymentTime: PaymentTime;
}) => {
  const { t } = useTranslation('bookingSummary');
  const isPreviewingAlternativeCurrency = usePreviewingAlternativeCurrency();

  const localisedTotal = useCurrencyPreview({
    amount: total,
    preventConversion: true,
  });

  if (!isPreviewingAlternativeCurrency) return null;

  return (
    <BodySmall color="textSecondary">
      {paymentTime === PaymentTime.PayNow
        ? t('alternativeCurrencyWarning.confirmation.payNow', {
            total: localisedTotal,
          })
        : t('alternativeCurrencyWarning.confirmation.payLater', {
            total: localisedTotal,
          })}
    </BodySmall>
  );
};
